import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalInfo, FPMessage, Severities, SourceSystem, ImageModel } from '../../../shared/shared.model';
import { FormControl, FormGroup, FormBuilder, Validators, RequiredValidator } from '@angular/forms';
import { BaseComponent } from '../../../shared/base.component';
import { Message, SelectItem, MultiSelectModule } from 'primeng/primeng';
import { SharedService } from '../../../shared/shared.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/primeng';
import { LoaderService } from '../../../shared/loader.service';
import { CapitalizeFirstPipe } from '../../../shared/pipes/custom-pipes.pipe';
import { ClosePopup, OutputValue, ChecklistDropdown, ChecklistModel, attachmentchecklist, ContactType, ChecklistAttachment, AttachmentsModel } from '../../../technician/technician-jobs/technician-jobs.models';
import { TechnicianJobService } from '../../../technician/technician-jobs/technician-jobs.service';
import { API } from '../../../core/app-config';
import { AuthService } from '../../../../authentication/auth.service';
import { RouteParams } from '../../../queues/approval-queue/approval-queue.model';


@Component({
    selector: 'addattachment-popup',
    templateUrl: 'addattachment-popup.html',
    styleUrls: ['../dynamic-forms-checklist.css'],
    encapsulation: ViewEncapsulation.None
})


export class addattachmentpopup extends BaseComponent implements OnInit {
    @Output() done = new EventEmitter();
    @Input() WoJobChecklistDetailId: number;
    @Input() ChklistDtlId: number;
    @Input() ChklistMastIdd: number;
    @Input() QuestionId: number;
    @Input() Question: string;
    @Input() jobid: number;
    @Input() wkid: number;
    @Input() StatusView: boolean;
    @ViewChild("fileInput") fileInput;
    @ViewChild('#idl') Dttype: ElementRef;
    //forms
    chkAttachements: FormGroup;
    contactType: ContactType[];
    cDate: Date;
    cTime: string;
    files = [];
    uploadedFiles: any[] = [];
    enableSavebt: boolean = true;
     MaxFileSize: number = 0;
    MaxFileSizeMB: number = 0;
    MaxFileSizeUnit: string = '';
    Filescheck: [];
    message: FPMessage;
    loader: boolean = false;
    acceptTypes: string;
    FileName: string;
    isCategorytype: boolean = false;
    AddAttachment: boolean = true;
    EditAttachment: boolean = false;
    AllButtonDisable: boolean = true;
    attachmentsList: ChecklistAttachment[] = [];
    attachmentsFilter: attachmentchecklist[] = [];
    attachmentsqueue: attachmentchecklist[] = [];
    rp = new RouteParams;
    returnvalue = new OutputValue();
    captureTime: string;
    captureDate: string;
    captureDateAndTime?: string;
    url: string;
    togglelist: boolean = false;
    stacked: boolean;
    val: any;
    valchk: any;
    togglelistt: boolean = true;
    isGridShowHide: Boolean = false;
    isGridThumbHide: boolean = true;
    isShowToggle: boolean = false;
    yearRange: string;
    ifPreview: boolean = false;
    previewImage: ImageModel[];
    currentAttachmentId: number;
    attachmentPreview: attachmentchecklist[] = [];
    attachmentPreviewFilter: attachmentchecklist[] = [];
    constructor(protected sharedService: SharedService, protected translate: TranslateService, private _fb: FormBuilder,
        private router: Router, private route: ActivatedRoute, private loaderservice: LoaderService, private authService: AuthService,
        private datePipe: DatePipe, private confirmationService: ConfirmationService, private _technicianJobService: TechnicianJobService) {
        super(sharedService, translate);
        this.yearRange = sharedService.yearRange;
    }
    ngOnInit() {
        this.formInilize();
        //
        this.sharedService.getSystemSettingByIds(this.globalInfo().CompanyId, 106).subscribe(val => {
            this.MaxFileSize = Number(val[0].SettingValue) * (1024 * 1024);
            //var sizeInMB = (file.size / (1024*1024)).toFixed(2);  // convertion filesize to MB
            this.MaxFileSizeMB = Number(val[0].SettingValue);
            this.MaxFileSizeUnit = val[0].SettingUnit;
        });
        this.getint();
        this.acceptTypes = "image/*";
        // this.getRouteParams();
        this.getchkattachment(0);
        this.chkAttachements.controls['AttachmentCategoryId'].valueChanges.subscribe(x => {
            this.fileInput.clear();
        });
        this.AllButtonDisable = this.StatusView == false ? true : this.AllButtonDisable;

    }

    formInilize() {
        this.chkAttachements = this._fb.group({
            Description: [""],
            AttachmentCategoryId: ["67"],
            AttachementTypeId: ["0"],
            CapturedDate: [""],
            CapturedTime: [""],
            WoJobChklistDtlListId: []
        });
    }

    getint() {
        this.cDate = new Date();
        this.cTime = this.datePipe.transform(this.cDate, 'shortTime');
        let attTypeId = this.chkAttachements.controls['AttachmentCategoryId'].value == 67 ? "23" : "24";
        this.getAttacheMentType(+attTypeId);
        this.chkAttachements.patchValue({
            AttachmentCategoryId: "67",
            AttachementTypeId: "0",
            CapturedDate: this.cDate,
            CapturedTime: this.cDate,
            Description: '',
        });

    }

    getAttacheMentType(id: number) {
        this.contactType = [];
        this._technicianJobService.getPhotoDocumentDetails(this.globalInfo().CompanyId, id)
            .subscribe(s => {
                this.contactType = s;
            });

    }
    showimage(model: attachmentchecklist[]) {
        this.loaderservice.show();

        // this._technicianJobService.getchklistAttachementsDetails(super.globalInfo().CompanyId,this.ChklistDtlId,this.ChklistMastIdd, this.WoJobChecklistDetailId, id)
        //     .subscribe(s => {
        this.attachmentsFilter = model;

        this.attachmentsqueue = [];
        // this.isShowToggle = this.attachmentsFilter.length > 0;


        for (let file of this.attachmentsFilter) {
            file.ImageTypes = file.FileName.split('.').pop();

            if (file.ImageTypes == "xls" || file.ImageTypes == "xlsx") {
                file.DocThumbImage = "../assets/img/logo/xls.png";
            }
            else if (file.ImageTypes == "doc" || file.ImageTypes == "docx") {
                file.DocThumbImage = "../assets/img/logo/document.png";
            }
            else if (file.ImageTypes == "ppt" || file.ImageTypes == "pptx") {
                file.DocThumbImage = "../assets/img/logo/ppt.png";
            }
            else if (file.ImageTypes == "txt") {
                file.DocThumbImage = "../assets/img/logo/document.png";
            }
            else if (file.ImageTypes == "pdf") {
                file.DocThumbImage = "../assets/img/logo/pdf.png";
            }
            else if (file.ImageTypes == "mp4") {
                file.DocThumbImage = "../assets/img/logo/movie.png";
            }
            else if (file.ImageTypes == "mp3") {
                file.DocThumbImage = "../assets/img/logo/mp3.png";
            }
            else if (file.ImageTypes == "dwg") {
                file.DocThumbImage = "../assets/img/logo/autocad.dwg";
            }
            else {
                file.DocThumbImage = "../assets/img/logo/unknown.png";
            }

            this.attachmentsqueue.push(file);
            console.log(this.attachmentsqueue);

        }
        this.loaderservice.hide();
        // });

        if (this.togglelistt = this.togglelistt == true ? false : true) {

            this.isGridShowHide = true;
            this.isGridThumbHide = false;

        } else {
            this.isGridShowHide = false;
            this.isGridThumbHide = true;
        }
    }
    showThumbNailView(id: number) {
        this.getchkattachment(id);

    }
    closePopup(OutputValue) {
        this.getchkattachment(0);
        this.returnvalue.success = false;
        this.returnvalue.QuestionId = this.ChklistDtlId;
        this.returnvalue.Count = this.attachmentsFilter.length;
        this.done.emit(this.returnvalue);
    }
    getPhotoType() {
        this.acceptTypes = "image/*";
        this.getAttacheMentType(23);
        this.chkAttachements.controls['AttachmentCategoryId'].valueChanges.subscribe(x => {
            this.fileInput.clear();
        });
    };

    getDocumentType() {
        this.acceptTypes = ".audio/*,xlsx,.xls,.doc,.docx,.ppt,.pptx,.txt,.pdf";
        this.getAttacheMentType(24);
        this.chkAttachements.controls['AttachmentCategoryId'].valueChanges.subscribe(x => {
            this.fileInput.clear();
        });
    }

    getchkattachment(id?: number) {

        this.loaderservice.show();

        this._technicianJobService.getchklistAttachementsDetails(super.globalInfo().CompanyId, this.ChklistDtlId, this.ChklistMastIdd, this.WoJobChecklistDetailId, id)
            .subscribe(s => {
                debugger;
                this.attachmentsFilter = s;
                this.showimage(this.attachmentsFilter);
                this.loaderservice.hide();
                this.isShowToggle = this.attachmentsFilter.length > 0;
            });

    }

    filterPhotoDocument(id: any) {
        this.getchkattachment(id);
        if (this.togglelistt == true) {
            this.togglelistt = false;
        }
        else {
            this.togglelistt = true;
        }
    }
    editAttachments(rowdata: attachmentchecklist) {

        this.AddAttachment = false;
        this.EditAttachment = true;
        this.isCategorytype = true;
        this.FileName = rowdata.FileName

        this.chkAttachements.patchValue({
            AttachmentCategoryId: rowdata.AttachmentCategoryId == 67 ? "67" : "68",
            Description: rowdata.Description,
            // CapturedDate:this.datePipe.transform(rowdata.CapturedDate, "MM/dd/yyyy"),
            // CapturedTime:this.datePipe.transform(rowdata.CapturedDate, 'shortTime'),
            WoJobChklistDtlListId: rowdata.WoJobChklistDtlListId,
        });
        let datec = this.datePipe.transform(rowdata.CapturedDate, "MM/dd/yyyy");
        let timec = this.datePipe.transform(rowdata.CapturedDate, 'shortTime')
        this.chkAttachements.controls['CapturedDate'].setValue(datec);
        this.chkAttachements.controls['CapturedTime'].setValue(rowdata.CapturedDate);
        this.chkAttachements.controls["AttachmentCategoryId"].disable();
        let attTypeId = rowdata.AttachmentCategoryId == 67 ? "23" : "24";
        this.getAttacheMentType(+attTypeId);
        this.chkAttachements.controls["AttachementTypeId"].setValue(rowdata.AttachementTypeId);

    }

    deleteAttachments(rowdata: attachmentchecklist) {
        this.getint();
        this.EditAttachment = false;
        if (this.togglelistt == true) { this.togglelistt = false; }
        else {
            this.togglelistt = true;
        }
        this.confirmationService.confirm({
            message: this.translate.instant('5001'),
            header: 'Delete Confirmation',
            icon: 'fa fa-trash',
            accept: () => {
                //Actual logic to perform a confirmation
                this.loaderservice.show();

                this._technicianJobService.DeleteChecklistattachment(super.globalInfo().CompanyId, this.jobid, rowdata.WoJobChklistDtlListId, this.ChklistDtlId, this.ChklistMastIdd)
                    .subscribe(s => {
                        this.message = s.Message;

                        if (s.Message.Severity == Severities.success) {
                            this.getchkattachment(0);
                            this.loaderservice.hide();
                            this.sharedService.notification.emit({
                                severity: Severities[this.message.Severity],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                detail: this.translate.instant("ATTACHMENTDELETEDSUCCESS")
                            });
                        }
                        else {
                            this.sharedService.notification.emit({
                                severity: Severities[this.message.Severity],
                                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                                detail: this.translate.instant(this.message.MessageCode)
                            });
                            this.loaderservice.hide();
                        }

                    });
            }
        });

    }

    onBeforeSend(event) {
        var ac_token = this.authService.getAuthorizationHeaderValue();
        event.xhr.setRequestHeader('Authorization', ac_token);
    }
    togglechange() {
        this.stacked = !this.stacked;
        this.togglelist = this.togglelist == true ? false : true
    }
    addNewAttachments() {
        this.getint();
        this.EditAttachment = false;
        this.AddAttachment = true;
        this.isCategorytype = false;
    }

    dowoloadFile(woAttachId: number) {
        var url = API.ATTACHEMNT + '/ManageDynamicAttachmentDownload?CompanyId=' + super.globalInfo().CompanyId + "&WoJobChklistDtlListId=" + woAttachId;
        window.location.href = url;//"http://localhost:13632/api/workorder/Download?CompanyId=" + this.companyId + "&WoAttachmentId=" + woAttachId;
        return;
    }
    savechkattachment(model: attachmentchecklist) {
        debugger;
        this.loaderservice.show();
        this.url = API.WORKORDER + '/ManageCheklistUploadFile?companyId=' + super.globalInfo().CompanyId + '&workorderId=' + this.wkid + '&woJobid=' + this.jobid + '&chklistid=' + this.WoJobChecklistDetailId;
        this.isShowToggle = false;


        if (model.WoJobChklistDtlListId != 0 && model.WoJobChklistDtlListId != null) {
            this.attachmentsList = [];

            this.attachmentsList.push({
                WoJobChklistDtlListId: model.WoJobChklistDtlListId,
                CompanyId: super.globalInfo().CompanyId,
                WoJobChklistDtlId: this.WoJobChecklistDetailId,
                AttachmentCategoryId: model.AttachmentCategoryId,
                AttachementTypeId: (model.AttachementTypeId == +"0" ? 0 : model.AttachementTypeId),
                Description: model.Description,
                CapturedDate: this.datePipe.transform(new Date(model.CapturedDate), "MM/dd/yyyy") + " " + this.datePipe.transform(model.CapturedTime, 'shortTime'),
                FileName: "",
                Attachment: "",
                FilePath: model.FilePath == "" ? " " : model.FilePath,
                CreatedSourceId: SourceSystem.Web,
                UpdatedSourceId: SourceSystem.Web,
                CreatedSourceLoginId: super.globalInfo().LoginId,
                UpdatedSourceLoginId: super.globalInfo().LoginId,
                CreatedBy: super.globalInfo().LoginId,
                CreatedDate: this.captureDateAndTime,
                LastChangedBy: super.globalInfo().LoginId,
                LastUpdate: "",
                WorkOrderId: this.wkid,
                WoJobId: this.jobid,
                ChklistDtlId: this.ChklistDtlId,
                ChklistMastId: this.ChklistMastIdd,
                QuestionId: this.QuestionId,
                Question: this.Question

            });

            this._technicianJobService.savechklistAttachement(this.attachmentsList).subscribe(res => {
                this.message = res.Message;

                if (res.Message.Severity == Severities.success) {
                    this.getint();
                    this.getchkattachment(0);

                    this.isCategorytype = false;
                    this.EditAttachment = false;
                    this.AddAttachment = true;
                    this.togglelistt = true
                    setTimeout(() => {
                        this.chkAttachements.controls["AttachmentCategoryId"].enable();
                        this.responceMessage();
                    }, 2500);

                }
                else {

                    this.responceMessage();
                }
            });


        }
        else {
            this.attachmentsList = [];

            //files: File = this.fileInput.files;
            this.files = this.fileInput.files;
            this.Filescheck = this.fileInput.files;
            if (this.files.length > 0) {
                this.files.forEach(x => {
                    this.val = this.attachmentsFilter.filter(y => y.FileName == x.name);
                });
                let cot = this.val.length;
                // this.valchk =  Array.from(new Set(this.files ));
                if (cot > 0) {
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("File name already Exist")
                    });
                    this.isShowToggle = this.attachmentsFilter.length > 0;
                    this.loaderservice.hide();
                    return;
                }
            }
            else {
                this.sharedService.notification.emit({
                    severity: Severities[2],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                    detail: this.translate.instant("No file selected")
                });
                this.isShowToggle = this.attachmentsFilter.length > 0;
                this.loaderservice.hide();
                return;

            }

            for (let file of this.files) {
                if (file == null || file == undefined) {
                    debugger
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("No file selected")
                    });
                    this.isShowToggle = this.attachmentsFilter.length > 0;
                    this.loaderservice.hide();
                    return;
                }

                if (file.size == 0) {
                    // alert("File size is 0 bytes");
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("File size is 0 bytes")
                    });
                    this.isShowToggle = this.attachmentsFilter.length > 0;
                    this.loaderservice.hide();
                    return;
                }

                if (!this.sharedService.isFileTypeValid(file, this.acceptTypes)) {
                    this.sharedService.notification.emit({
                        severity: Severities[2],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                        detail: this.translate.instant("Invalid file type")
                    });
                    this.isShowToggle = this.attachmentsFilter.length > 0;
                    this.loaderservice.hide();
                    return;
                }
                if (model.CapturedDate != null && model.CapturedDate) {
                    this.captureTime = this.datePipe.transform(model.CapturedTime, 'shortTime');
                    this.captureDate = this.datePipe.transform(new Date(model.CapturedDate), "MM/dd/yyyy");
                    this.captureDateAndTime = this.captureDate + " " + this.captureTime;
                }
                else {
                    this.captureDateAndTime = null;
                }


                this.attachmentsList.push({
                    WoJobChklistDtlListId: 0,
                    CompanyId: super.globalInfo().CompanyId,
                    WoJobChklistDtlId: this.WoJobChecklistDetailId,
                    AttachmentCategoryId: model.AttachmentCategoryId,
                    AttachementTypeId: (model.AttachementTypeId == +"0" ? 0 : model.AttachementTypeId),
                    Description: model.Description,
                    CapturedDate: this.captureDateAndTime.toLocaleString(),
                    FileName: file.name,
                    Attachment: "",
                    FilePath: model.FilePath == "" ? " " : model.FilePath,
                    CreatedSourceId: SourceSystem.Web,
                    UpdatedSourceId: SourceSystem.Web,
                    CreatedSourceLoginId: super.globalInfo().LoginId,
                    UpdatedSourceLoginId: super.globalInfo().LoginId,
                    CreatedBy: super.globalInfo().LoginId,
                    CreatedDate: this.captureDateAndTime,
                    LastChangedBy: super.globalInfo().LoginId,
                    LastUpdate: "",
                    WorkOrderId: this.wkid,
                    WoJobId: this.jobid,
                    ChklistDtlId: this.ChklistDtlId,
                    ChklistMastId: this.ChklistMastIdd,
                    QuestionId: this.QuestionId,
                    Question: this.Question

                });
            }

            this._technicianJobService.savechklistAttachement(this.attachmentsList).subscribe(res => {
                this.message = res.Message;
                if (res.Message.Severity == Severities.success) {
                    this.fileInput.upload()
                    this.getint();
                    this.togglelistt = true

                    setTimeout(() => {
                        this.getchkattachment(0);
                        this.responceMessage();
                        this.getPhotoType(); // Fixes for Failed to change the PhotoType values after adding document's - Added by KP on 13/10/2020
                    }, 2500);

                }
                else {

                    this.responceMessage();
                }
            });
        }


    }

    responceMessage() {
        this.loaderservice.hide();
        debugger;
        if (this.message.MessageCode == "1001" || this.message.MessageCode == "1002") {

            this.sharedService.notification.emit({
                severity: Severities[this.message.Severity],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                detail: this.translate.instant('ATTACHMENT') + " " + this.translate.instant(this.message.MessageCode)
            });

        }
        else {
            this.sharedService.notification.emit({
                severity: Severities[this.message.Severity],
                summary: CapitalizeFirstPipe.prototype.transform(Severities[this.message.Severity]),
                detail: this.translate.instant(this.message.MessageCode)
            });
        }
    }

    previewAttachments(rowdata: attachmentchecklist) {
        this.previewImage = [];

        this._technicianJobService.getJobFormAttachementsImage(super.globalInfo().CompanyId, this.jobid, rowdata.WoJobChklistDtlId)
            .subscribe(resp => {
                resp.forEach(d => {

                    var imageModel = new ImageModel()
                    imageModel.Attachment = d.Attachment;
                    imageModel.FileName = d.FileName;
                    imageModel.Description = d.Description;
                    imageModel.AttachmentId = d.WoAttachmentId;
                    this.previewImage.push(imageModel);
                });
                this.currentAttachmentId = rowdata.WoJobChklistDtlListId;
                this.ifPreview = true;
            });

    }
    closePreview() {
        this.ifPreview = false;
    }

    onSelect(event) {
        debugger;
        var duplicateFile: any[] = [];

        this.fileInput.files.forEach((element) => {
            if (element.size == 0) {
                this.sharedService.notification.emit({
                    severity: Severities[2],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                    detail: this.translate.instant("FILESIZEZEROBYTE")
                });
                duplicateFile.push(element);
            }
            if (element.size > this.MaxFileSize) {
                this.sharedService.notification.emit({
                    severity: Severities[2],
                    summary: CapitalizeFirstPipe.prototype.transform(Severities[2]),
                    detail: this.translate.instant("UPLOADLIMIT") + this.MaxFileSizeMB.toString() + this.MaxFileSizeUnit
                });
                duplicateFile.push(element);
            }
        });

//INVALIDFILETYPE
             this.fileInput.files.forEach((element) => {
                if (!this.sharedService.isFileTypeValid(element, this.acceptTypes)) {
                    this.sharedService.notification.emit({
                        severity: Severities[3],
                        summary: CapitalizeFirstPipe.prototype.transform(Severities[3]),
                        detail: this.translate.instant("INVALIDFILETYPE")
                    });
                    duplicateFile.push(element);
                }
             
            });
//

        this.fileInput.files.forEach((element) => {
            if (this.uploadedFiles.length > 0 && this.uploadedFiles.filter(x => x.name == element.name).length > 0) {
                duplicateFile.push(element);
            }
        });
        duplicateFile.forEach(index => {
            var temp = this.fileInput.files.findIndex(x => x.name == index.name);
            this.fileInput.files.splice(temp, 1);
        });
        if (this.fileInput.files.length > 0) {
            this.enableSavebt = false;
        }
    }
    
}